/** The server's own message when it sent one; ErrorResponse uses errorMessage, GenericResponse message. */
export const getApiError = (err, fallback) =>
  err?.response?.data?.errorMessage || err?.response?.data?.message || fallback;
